const KEY = "whatisinside.favorites.v1";
const OLD_KEYS = ["ingredientiq.favorites.v1"];

// One-time migration: move favorites from the old IngredientIQ key to the new one
(() => {
  try {
    if (localStorage.getItem(KEY)) return;
    for (const ok of OLD_KEYS) {
      const old = localStorage.getItem(ok);
      if (old) {
        localStorage.setItem(KEY, old);
        localStorage.removeItem(ok);
        break;
      }
    }
  } catch {}
})();

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

const write = (list) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent("favorites-changed"));
  } catch {}
};

export const getFavorites = () => read();

export const isFavorite = (slug) => read().some((f) => f.slug === slug);

export const toggleFavorite = (item) => {
  const list = read();
  const idx = list.findIndex((f) => f.slug === item.slug);
  if (idx >= 0) {
    list.splice(idx, 1);
  } else {
    list.unshift({
      slug: item.slug,
      productName: item.productName,
      brand: item.brand,
      overallScore: item.overallScore,
      overallRating: item.overallRating,
      savedAt: new Date().toISOString(),
    });
  }
  write(list);
  return list;
};

export const removeFavorite = (slug) => {
  const list = read().filter((f) => f.slug !== slug);
  write(list);
  return list;
};

export const onFavoritesChange = (fn) => {
  const handler = () => fn(read());
  window.addEventListener("favorites-changed", handler);
  window.addEventListener("storage", handler);
  return () => {
    window.removeEventListener("favorites-changed", handler);
    window.removeEventListener("storage", handler);
  };
};
